namespace TabAurous.OMS {
    export interface CompanyForm {
        CompanyCode: Serenity.StringEditor;
        TypeOfCompany: CompanyEditor;
        ParentCompany: Serenity.LookupEditor;
        DiscountingPolicyId: Serenity.LookupEditor;
        MarkUpPolicyId: Serenity.LookupEditor;
        CompanyName: Serenity.StringEditor;
        MailingName: Serenity.StringEditor;
        Logo: Serenity.ImageUploadEditor;
        Address: Serenity.TextAreaEditor;
        Phone: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        EmailId: Serenity.EmailAddressEditor;
        Web: Serenity.StringEditor;
        Country: Serenity.LookupEditor;
        State: Serenity.LookupEditor;
        Pin: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        TaxGroupId: Serenity.LookupEditor;
        LedgerId: Serenity.LookupEditor;
        TIN: Serenity.StringEditor;
        CST: Serenity.StringEditor;
        PAN: Serenity.StringEditor;
        CurrentDate: Serenity.DateEditor;
        IsDefault: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsPriceList: Serenity.BooleanEditor;
        PPriceListId: Serenity.LookupEditor;
        PMarkup: Serenity.DecimalEditor;
        SPriceListId: Serenity.LookupEditor;
        SMarkup: Serenity.DecimalEditor;
        IsLabourList: Serenity.BooleanEditor;
        PLabourListId: Serenity.LookupEditor;
        PLMarkup: Serenity.DecimalEditor;
        SLabourListId: Serenity.LookupEditor;
        SLMarkup: Serenity.DecimalEditor;
    }

    export class CompanyForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Company';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CompanyForm.init)  {
                CompanyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = CompanyEditor;
                var w2 = s.LookupEditor;
                var w3 = s.ImageUploadEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.EmailAddressEditor;
                var w6 = s.DateEditor;
                var w7 = s.BooleanEditor;
                var w8 = s.DecimalEditor;

                Q.initFormType(CompanyForm, [
                    'CompanyCode', w0,
                    'TypeOfCompany', w1,
                    'ParentCompany', w2,
                    'DiscountingPolicyId', w2,
                    'MarkUpPolicyId', w2,
                    'CompanyName', w0,
                    'MailingName', w0,
                    'Logo', w3,
                    'Address', w4,
                    'Phone', w0,
                    'Mobile', w0,
                    'EmailId', w5,
                    'Web', w0,
                    'Country', w2,
                    'State', w2,
                    'Pin', w0,
                    'CurrencyId', w2,
                    'TaxGroupId', w2,
                    'LedgerId', w2,
                    'TIN', w0,
                    'CST', w0,
                    'PAN', w0,
                    'CurrentDate', w6,
                    'IsDefault', w7,
                    'IsDisabled', w7,
                    'IsPriceList', w7,
                    'PPriceListId', w2,
                    'PMarkup', w8,
                    'SPriceListId', w2,
                    'SMarkup', w8,
                    'IsLabourList', w7,
                    'PLabourListId', w2,
                    'PLMarkup', w8,
                    'SLabourListId', w2,
                    'SLMarkup', w8
                ]);
            }
        }
    }
}
